import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppShell } from "../components/Layout";
import { api, formatINR, timeAgo } from "../lib/api";
import { Flame, AlertTriangle, Split } from "lucide-react";

const STATUS_COLORS = {
  pending: "bg-amber-500 text-black",
  approved: "bg-slate-700 text-white",
  rejected: "bg-slate-500 text-white",
  paid: "bg-olive text-white",
  recorded: "bg-olive text-white",
  closed: "bg-black text-white",
};

export default function MyRequests() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/requests?mine=true").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = items.filter((r) => filter === "all" || r.status === filter);

  return (
    <AppShell back="/dashboard" title="MY REQUESTS">
      <div className="px-5 py-5 space-y-4">
        <h2 className="font-display font-black text-2xl tracking-tighter uppercase">
          {items.length} <span className="text-slate-400">TOTAL</span>
        </h2>

        <div className="grid grid-cols-5 gap-0 border-t border-l border-black/20">
          {["all", "pending", "approved", "recorded", "rejected"].map((f) => (
            <button
              key={f}
              data-testid={`myfilter-${f}`}
              onClick={() => setFilter(f)}
              className={`py-2 border-r border-b border-black/20 font-mono text-[9px] uppercase tracking-widest font-bold ${
                filter === f ? "bg-black text-white" : "bg-white text-black"
              }`}
            >
              {f.slice(0, 4).toUpperCase()}
            </button>
          ))}
        </div>

        {loading && <div className="label-micro">LOADING…</div>}
        {!loading && filtered.length === 0 && (
          <div className="p-10 text-center font-mono text-xs uppercase tracking-widest text-slate-400">
            NO REQUESTS
          </div>
        )}
        <div className="space-y-0">
          {filtered.map((r) => {
            const flags = r.flags || {};
            return (
              <button
                key={r.request_id}
                data-testid={`my-req-${r.request_id}`}
                onClick={() => navigate(`/requests/${r.request_id}`)}
                className="w-full text-left bg-white border-b-2 border-black/10 px-5 py-4 hover:bg-slate-50"
              >
                <div className="flex justify-between items-start mb-1">
                  <div>
                    <div className="font-display font-black text-sm uppercase">{r.vendor_name}</div>
                    <div className="label-micro mt-0.5">{r.site} · {r.category}</div>
                  </div>
                  <span className={`font-mono text-[9px] uppercase tracking-widest font-bold px-2 py-0.5 ${STATUS_COLORS[r.status]}`}>
                    {r.status}
                  </span>
                </div>
                <div className="flex items-end justify-between mt-2">
                  <div className="font-display font-black text-2xl tracking-tighter">{formatINR(r.amount)}</div>
                  <div className="flex items-center gap-1.5">
                    {r.urgency === "emergency" && <Flame size={14} className="text-red-600"/>}
                    {flags.post_facto && <AlertTriangle size={14} className="text-yellow-600"/>}
                    {flags.split && <Split size={14} className="text-yellow-600"/>}
                    <span className="label-micro">{timeAgo(r.created_at)}</span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </AppShell>
  );
}
